import { Role } from 'src/Enum/Report';
import { IFinancialStatementsFormValues } from './Containers/FinancialStatementsProvider/types';

export const mappingFinancialStatementsToPayload = (
  values: IFinancialStatementsFormValues
) => {
  const defaultCompletedSection = {
    id: null,
    isCompletedTh: false,
    isCompletedEn: false,
    roleStampTh: Role.NONE,
    roleStampEn: Role.NONE,
    dateTh: null,
    dateEn: null,
  };

  const formattedOtherDescriptions = (values.otherDescriptions || []).map(
    (desc, index) => ({
      id: desc.id,
      sequence: index + 1,
      titleTh: desc.titleTh || '',
      titleEn: desc.titleEn || '',
      descriptionTh: desc.descriptionTh || '',
      descriptionEn: desc.descriptionEn || '',
    })
  );

  return {
    id: values.id ?? null,
    completedSection: {
      ...defaultCompletedSection,
      ...values.completedSection,
      id: values.completedSection?.id ?? null,
      isCompletedTh: values.completedSection?.isCompletedTh ?? false,
      isCompletedEn: values.completedSection?.isCompletedEn ?? false,
      roleStampTh: values.completedSection?.roleStampTh ?? Role.NONE,
      roleStampEn: values.completedSection?.roleStampEn ?? Role.NONE,
      dateTh: values.completedSection?.dateTh ?? null,
      dateEn: values.completedSection?.dateEn ?? null,
    },
    otherDescriptions: formattedOtherDescriptions,
  };
};
